<div class="signup">
  <div class="card col-12 col-md-3 offset-md-2 px-5 py-5">
    <img *ngIf="logo" class="mb-5 logo-edunet" [src]="logo" alt="logo">
    <ng-container *ngIf="mode === 'signup'">
      <div *ngIf="!isSignupEmail && !isSignupPhone" class="social-sign-up">
        <button (click)="signInWithFb()" class="w-100" nz-button nzType="default" nzSize="large" nzShape="round">
          <img class="social-signup__icon social-signup__icon--fb" src="assets/icons/icons8-facebook-48.png"
               alt="facebook">
          <span>{{ 'signup.withFb' | transloco }}</span>
        </button>
        <button (click)="signInWithGg()" class="w-100 mt-4" nz-button nzType="default" nzSize="large" nzShape="round">
          <img class="social-signup__icon social-signup__icon--gg" src="assets/icons/icons8-google-48.png" alt="google">
          <span>{{ 'signup.withGg' | transloco }}</span>
        </button>
        <button (click)="signInWithEmail()" class="w-100 mt-4" nz-button nzType="default" nzSize="large" nzShape="round">
          <img class="social-signup__icon social-signup__icon--email" src="assets/icons/icons8-email-64.png" alt="google">
          <span>{{ 'signup.withEmail' | transloco }}</span>
        </button>
        <button (click)="signInWithPhone()" class="w-100 mt-4" nz-button nzType="default" nzSize="large"
                nzShape="round">
          <img class="social-signup__icon social-signup__icon--email" src="assets/icons/icons8-phone-64.png"
               alt="google">
          <span>{{ 'signup.withPhone' | transloco }}</span>
        </button>
        <div class="mt-5" style="font-size: 14px;">{{ 'signup.haveAcc' | transloco }} <a
          [routerLink]="'/login'">{{ 'signup.loginNow' | transloco }}</a></div>
      </div>

      <div *ngIf="isSignupEmail" class="signup-with-email">
        <form nz-form [formGroup]="signupForm" class="signup-form" (ngSubmit)="signup()">
          <nz-form-item>
            <nz-form-control
              [nzErrorTip]="firstNameErrTpl">
              <nz-input-group nzPrefixIcon="user">
                <input type="text" nz-input formControlName="firstName"
                       placeholder="{{ 'signup.firstNamePlaceholder' | transloco }}" maxlength="50"/>
              </nz-input-group>
              <ng-template #firstNameErrTpl>
                <ng-container
                  *ngIf="signupForm.hasError('required', 'firstName')">{{ 'signup.requiredFirstName' | transloco }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control>
              <nz-select class="select-kps" formControlName="class"
                         nzPlaceHolder="{{ 'signup.class' | transloco }}">
                <nz-option *ngFor="let class of classList" [nzValue]="class.key" [nzLabel]="class.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control
              [nzErrorTip]="mailErrTpl">
              <nz-input-group nzPrefixIcon="mail">
                <input appRemoveWhitespaceCharsOnPaste type="text" nz-input formControlName="email" placeholder="Email"/>
              </nz-input-group>
              <ng-template #mailErrTpl>
                <ng-container
                  *ngIf="signupForm.hasError('required', 'email')">{{ 'signup.requiredEmail' | transloco }}</ng-container>
                <ng-container
                  *ngIf="!signupForm.hasError('required', 'email')">{{ 'signup.invalidEmail' | transloco }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="mt-2">
            <nz-form-control [nzErrorTip]="pwErrTpl">
              <nz-input-group nzPrefixIcon="lock" [nzSuffix]="suffixTemplate">
                <input appRemoveWhitespaceCharsOnPaste [type]="passwordVisible ? 'text' : 'password'" nz-input formControlName="password"
                       placeholder="{{ 'signup.pwPlaceholder' | transloco }}" autocomplete="off"/>
              </nz-input-group>
              <ng-template #suffixTemplate>
                <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                   (click)="passwordVisible = !passwordVisible"></i>
              </ng-template>
              <ng-template #pwErrTpl>
                <ng-container
                  *ngIf="signupForm.hasError('required', 'password')">{{ 'signup.requiredPw' | transloco }}</ng-container>
                <ng-container
                  *ngIf="!signupForm.hasError('required', 'password')">{{ 'signup.invalidPw' | transloco }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <ul class="pw-rule__list">
<!--            <li class="pw-rule__item">-->
<!--              <img *ngIf="!pwValidatorRes.letter" class="pw-rule__icon" src="assets/images/unchecked.svg" alt="unchecked">-->
<!--              <img *ngIf="pwValidatorRes.letter" class="pw-rule__icon" src="assets/images/checked.svg" alt="checked">-->
<!--              {{ 'signup.charLengthPw' | transloco }}-->
<!--            </li>-->
<!--            <li class="pw-rule__item">-->
<!--              <img *ngIf="!pwValidatorRes.number" class="pw-rule__icon" src="assets/images/unchecked.svg" alt="unchecked">-->
<!--              <img *ngIf="pwValidatorRes.number" class="pw-rule__icon" src="assets/images/checked.svg" alt="checked">-->
<!--              {{ 'signup.numberLengthPw' | transloco }}-->
<!--            </li>-->
<!--            <li class="pw-rule__item">-->
<!--              <img *ngIf="!pwValidatorRes.special" class="pw-rule__icon" src="assets/images/unchecked.svg"-->
<!--                   alt="unchecked">-->
<!--              <img *ngIf="pwValidatorRes.special" class="pw-rule__icon" src="assets/images/checked.svg" alt="checked">-->
<!--              {{ 'signup.specialCharLengthPw' | transloco }}-->
<!--            </li>-->
            <li class="pw-rule__item">
              <img *ngIf="!pwValidatorRes.length" class="pw-rule__icon" src="assets/images/unchecked.svg" alt="unchecked">
              <img *ngIf="pwValidatorRes.length" class="pw-rule__icon" src="assets/images/checked.svg" alt="checked">
              {{ 'signup.pwLength' | transloco }}
            </li>
          </ul>
          <button nz-button [disabled]="signupForm.invalid" [nzLoading]="loading"
                  class="signup-form-button mt-4 d-flex justify-content-center"
                  nzType="primary">{{ 'signup.submitBtn' | transloco }}</button>
          <div>
            <a class="mt-4 d-flex align-items-center" (click)="isSignupEmail=false;"><i nz-icon nzType="double-left"
                                                                                        nzTheme="outline"></i> {{ 'signup.back' | transloco }}
            </a>
          </div>
        </form>
      </div>
      <div *ngIf="isSignupPhone" class="signup-with-email">
        <form nz-form [formGroup]="signupFormByPhone" class="signup-form" (ngSubmit)="signup()">
          <nz-form-item>
            <nz-form-control
              [nzErrorTip]="firstNameErrTpl">
              <nz-input-group nzPrefixIcon="user">
                <input type="text" nz-input formControlName="firstName"
                       placeholder="{{ 'signup.firstNamePlaceholder' | transloco }}" maxlength="50"/>
              </nz-input-group>
              <ng-template #firstNameErrTpl>
                <ng-container
                  *ngIf="signupFormByPhone.hasError('required', 'firstName')">{{ 'signup.requiredFirstName' | transloco }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control>
              <nz-select class="select-kps" formControlName="class"
                         nzPlaceHolder="{{ 'signup.class' | transloco }}">
                <nz-option *ngFor="let class of classList" [nzValue]="class.key" [nzLabel]="class.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control
              [nzErrorTip]="mailErrTpl">
              <nz-input-group nzPrefixIcon="phone">
                <input type="text" nz-input formControlName="phone" placeholder="Phone"/>
              </nz-input-group>
              <ng-template #mailErrTpl>
                <ng-container
                  *ngIf="signupFormByPhone.hasError('required', 'phone')">{{ 'signup.requiredEmail' | transloco }}</ng-container>
                <ng-container
                  *ngIf="!signupFormByPhone.hasError('required', 'phone')">{{ 'signup.invalidPhone' | transloco }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="mt-2">
            <nz-form-control [nzErrorTip]="pwErrTpl">
              <nz-input-group nzPrefixIcon="lock" [nzSuffix]="suffixTemplate">
                <input [type]="passwordVisible ? 'text' : 'password'" nz-input formControlName="password"
                       placeholder="{{ 'signup.pwPlaceholder' | transloco }}" autocomplete="off"/>
              </nz-input-group>
              <ng-template #suffixTemplate>
                <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                   (click)="passwordVisible = !passwordVisible"></i>
              </ng-template>
              <ng-template #pwErrTpl>
                <ng-container
                  *ngIf="signupFormByPhone.hasError('required', 'password')">{{ 'signup.requiredPw' | transloco }}</ng-container>
                <ng-container
                  *ngIf="!signupFormByPhone.hasError('required', 'password')">{{ 'signup.invalidPw' | transloco }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <ul class="pw-rule__list">
            <li class="pw-rule__item">
              <img *ngIf="!pwValidatorRes.length" class="pw-rule__icon" src="assets/images/unchecked.svg"
                   alt="unchecked">
              <img *ngIf="pwValidatorRes.length" class="pw-rule__icon" src="assets/images/checked.svg" alt="checked">
              {{ 'signup.pwLength' | transloco }}
            </li>
          </ul>
          <button nz-button [disabled]="signupFormByPhone.invalid"
                  class="signup-form-button mt-4" [nzType]="'primary'"
                  [nzLoading]="loading">{{ 'signup.submitBtn' | transloco }}</button>
          <div>
            <a class="mt-4 d-flex align-items-center" (click)="isSignupPhone=false;"><i nz-icon nzType="double-left"
                                                                                        nzTheme="outline"></i> {{ 'signup.back' | transloco }}
            </a>
          </div>
        </form>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-4" style="font-size: 14px;">
        <label class="me-3">{{ 'language.chooseLang' | transloco }}</label>
        <app-lang-select></app-lang-select>
      </div>
    </ng-container>
    <ng-container *ngIf="mode === 'otp'">
      <h3 class="my-4">
        {{ 'signup.inputVerifyCode' | transloco }}
      </h3>
      <ng-otp-input (onInputChange)="onOtpInputChanged($event)"  [config]="{ length: 6, allowNumbersOnly: true, inputClass: 'signup-otp' }"></ng-otp-input>
      <div class="mt-4">
        <div>
          <span class="me-2">{{ 'signup.expiredAfter' | transloco }}</span>
          <span class="me-2">{{ otpExpiredTime }}</span>
          <span>{{ 'common.minutes' | transloco }}</span>
        </div>
        <div class="d-flex justify-content-between mt-5">
          <button (click)="resendOtp()" nz-button nzType="link">{{ 'signup.resend' | transloco }}</button>
          <button
            (click)="verifyOtp()"
            nz-button
            [disabled]="!enableVerifyBtn"
            [nzLoading]="isVerifying"
            class="d-flex justify-content-center"
            type="button"
            nzType="primary"
          >
            {{ 'signup.verifyBtn' | transloco }}
          </button>
        </div>
      </div>
    </ng-container>
    <div class="mt-5 hadtech-logo-container"><img class="hadtech-logo" src="assets/images/logo.svg" alt="logo"></div>
  </div>
</div>

<ng-template #signupErrorTpl>
  <nz-alert
    nzType="error"
    [nzDescription]="signupErrorMsgTpl"
    nzShowIcon
  >
    <ng-template #signupErrorMsgTpl>
      <div style="padding-right: 18px;">{{ signupError }}</div>
    </ng-template>
  </nz-alert>
</ng-template>
<ng-template #loginErrorTpl>
  <nz-alert
    nzType="error"
    [nzDescription]="loginErrorMsgTpl"
    nzShowIcon
  >
    <ng-template #loginErrorMsgTpl>
      <div style="padding-right: 18px;">{{ loginError }}</div>
    </ng-template>
  </nz-alert>
</ng-template>
<ng-container *ngIf="showNotiPopup">
  <app-note-popup (onClickOk)="showNotiPopup = false"></app-note-popup>
</ng-container>
